<button
  type="button"
  class="btn-govco outline-btn-govco ms-3 px-1 py-2"
  data-bs-toggle="modal"
  [attr.data-bs-target]="'#' + generateModalId(title)"
  aria-label="Abrir modal">
  <span class="govco-book"></span>
</button>

<div
  class="modal fade"
  [id]="generateModalId(title)"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-{{
      sizeModal
    }}">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title h5-tipografia-govco"
        *ngIf="title">{{ title }}</h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeModal()"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <ng-container [ngSwitch]="contentType">
          <ng-container *ngSwitchCase="'text'">
            <p class="text2-tipografia-govco">{{ content }}</p>
          </ng-container>
          <ng-container *ngSwitchCase="'list'">
            <ul class="list-group">
              <li class="list-group-item">{{ content }}</li>
            </ul>
          </ng-container>
          <ng-container *ngSwitchCase="'image'">
            <img [src]="content" class="img-fluid" alt="Content image" />
          </ng-container>
          <ng-container *ngSwitchCase="'component'">
            <ng-container *ngComponentOutlet="dynamicComponent"></ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn-govco fill-btn-govco"
          (click)="closeModal()"
          aria-label="Close">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
